import apiSlice from "../apiSlice";
import { setCredentials, clearCredentials } from "./authSlice";

export const authApis = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    registerUser: builder.mutation({
      query: (userData) => ({
        url: "/register",
        method: "POST",
        body: userData,
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;

          dispatch(
            setCredentials({
              token: data.token,
              user: {
                emailAddress: data.user.emailAddress,
                userId: data.user._id,
                role: data.user.role,
              },
            }),
          );
        } catch (error) {
          console.error("OTP verification failed:", error);
        }
      },
    }),

    generateOtp: builder.mutation({
      query: (otpData) => ({
        url: "/generate-otp",
        method: "POST",
        body: otpData,
      }),

      invalidatesTags: ["Auth"],
    }),

    login: builder.mutation({
      query: (userData) => ({
        url: "/login",
        method: "POST",
        body: userData,
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;

          dispatch(
            setCredentials({
              token: data.token,
              user: {
                emailAddress: data.user.emailAddress,
                userId: data.user.userId,
                role: data.user.role,
              },
            }),
          );
        } catch (error) {
          console.error("OTP verification failed:", error);
        }
      },
    }),

    logout: builder.mutation({
      query: () => ({
        url: "/logout",
        method: "POST",
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (error) {
          console.error("Logout failed:", error);
        } finally {
          dispatch(clearCredentials());
          dispatch(apiSlice.util.resetApiState());
        }
      },
      invalidatesTags: ["Auth"],
    }),

    getAllUsers: builder.query({
      query: () => ({
        url: "/getAllUsers",
        method: "GET",
      }),
      providesTags: ["User"],
    }),

    getUserById: builder.query({
      query: (userId) => ({
        url: `/getUser/${userId}`,
        method: "GET",
      }),
      providesTags: ["User"],
    }),
  }),
});

export const {
  useRegisterUserMutation,
  useGenerateOtpMutation,
  useGetAllUsersQuery,
  useLoginMutation,
  useLogoutMutation,
  useGetUserByIdQuery,
} = authApis;
